import PdfService from '../../pdfService';

export const GetPdfLicenseKey = async (authToken: string): Promise<string | undefined> => {
  const service = new PdfService(authToken);
  const result = await service.pdfService.get('GetPdfLicenseKey');

  return result.data;
};
